export default __webpack_public_path__ + "static/media/linkedin.e7d62931.svg";